import React, { useState } from "react";
import { saveTopic } from "./../../../services/topics";
import MyEditor from "./../../../components/common/Editor"

const EditPost = ({ Post, submitForm, loadPage, topicNarrative }) => {
  const [editPost, setEditPost] = useState(topicNarrative);

  const editThread = (content) => {
    setEditPost(content);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const editPostData = {
      ...Post,
      _id: Post._id,
      narrative: editPost,
    };

    try {
      await saveTopic(editPostData);
      submitForm(e);
      loadPage();
    } catch (error) {
      console.error("Error saving post:", error);
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    submitForm(null, "cancel");
  };

  return (
    <div className="col-lg-12 ml-2">
      <div className="row justify-content-center">
        <form onSubmit={handleSubmit}>
          <MyEditor
            initialContent={editPost}
            onChangeHandler={(text) => editThread(text)}
          />
          <div className="mt-1">
            <button
              className="btn btn-outline-secondary btn-sm mr-1"
              type="submit"
            >
              Submit
            </button>
            <button
              className="btn btn-outline-secondary btn-sm"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPost;
